export const UsedCarShopStyleApi = 'wx/usedcarshopstyle/' // 获得店铺的二手车的品牌和系列
export const UsedCarShopApi = 'wx/usedcarshop/' // 店铺二手车
export const UsedCarFavoritesApi = 'wx/usedcarfavorites/' // 店铺二手车
export const UsedCarOrderApi = 'wx/usedcarorder/' // 二手车订单
